import styled from "styled-components";
import { Table } from "antd";

export const StyledTable = styled(Table)`
    width: 850px;

    thead > tr > th {
        background-color: ${({ theme }) => theme.color.historyTableHeader};
        font-size: 14px;
        font-weight: 600;
    }

    tbody > tr > td {
        padding-top: 1px;
        padding-bottom: 1px;
    }

    .ant-table.ant-table-bordered
        > .ant-table-container
        > .ant-table-content
        > table
        > thead
        > tr
        > th {
        border-right: 1px solid rgba(98, 147, 97, 0.15);
    }

    .ant-pagination-next,
    .ant-pagination-prev {
        display: none;
    }

    .ant-pagination-item {
        border: none;
        min-width: auto;
        background: none;

        :hover {
            color: ${({ theme }) => theme.color.splitPanel};
        }
    }

    .ant-pagination-item-active {
        background: ${({ theme }) => theme.color.splitPanel};
        border-radius: 3px;

        a {
            color: white;
        }
    }

    > .ant-spin-text {
        color: #999;
    }

    .ant-spin-dot-item {
        background-color: ${({ theme }) => theme.text.mainGreen};
    }

    .ant-pagination-options {
        display: none;
    }
`;

export const Box = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    > .ant-typography {
        height: 24px;
    }

    svg:hover {
        cursor: pointer;
    }
`;
